jQuery(function($){
    if ($('.platform').length == 0){
        return;
    }

    let navItems = $('.platform__nav-item');
    
    // Loop over each platform__item
    $('.platform__item').each(function(index){
        let item = $(this);

        // Use the current item as the intersection trigger
        let intersectTrigger = item[0];  // jQuery object to plain DOM element

        // Function to handle intersections
        function handleIntersect(entries, observer) {
            entries.forEach(entry => {       
                if (entry.isIntersecting) {  
                    // Get corresponding nav item using the index
                    navItems.removeClass('active'); // Remove active from all nav items
                    navItems.eq(index).addClass('active'); // Add active class to the current nav item
                }
            });
        }

        // Create a new observer
        const observer = new IntersectionObserver(handleIntersect, {
            root: null, // viewport
            threshold: 0.8
        });

        observer.observe(intersectTrigger);
    });


    $('.platform__nav-item').on('click', function (e) {
        e.preventDefault(); // Prevent the default link behavior

        // Remove 'active' class from all nav items and add it to the clicked one
        $('.platform__nav-item').removeClass('active');
        $(this).addClass('active');

        // Get the target section ID from the data-target attribute
        var target = $('#' + $(this).data('target'));

        if (target.length) {
            // Calculate the offset position, adjusting for the 120px
            var targetPosition = target.offset().top - 140;
            var startPosition = window.pageYOffset;
            var distance = targetPosition - startPosition;
            var duration = 10; // in ms
            var startTime = null;

            // Animation loop using requestAnimationFrame
            function scrollAnimation(currentTime) {
                if (!startTime) startTime = currentTime;

                var timeElapsed = currentTime - startTime;
                var progress = Math.min(timeElapsed / duration, 1); // Ensure progress doesn't exceed 1
                var scrollPosition = startPosition + (distance * progress);

                window.scrollTo(0, scrollPosition);

                if (progress < 1) {
                    requestAnimationFrame(scrollAnimation); // Continue animation
                }
            }

            requestAnimationFrame(scrollAnimation);
        }
    });

    


});